import Flex from '@components/Flex/Flex';
import { useEffect, useState } from 'react';
import { ChoiceInputProps } from './ChoiceInput.types';
import { IconCompleted, StyledButton } from './ChoiceInput.styles';

const ChoiceInput: React.FC<ChoiceInputProps> = ({
  choices,
  onChange,
  defaultValues,
  showIconCompletedOnSelected = false,
  direction = 'column',
  readonly = false,
  fullWidth = false,
  multiple = false,
  disableRipple = false,
}) => {
  const [selected, setSelected] = useState(defaultValues ?? []);

  useEffect(() => setSelected(defaultValues ?? []), [defaultValues]);

  const handleClick = (current: string | number | boolean) => {
    if (!readonly) {
      if (!multiple) setSelected([current]);
      if (multiple) {
        if (!selected.includes(current)) {
          selected.push(current);
        } else {
          selected.splice(selected.indexOf(current), 1); //deleting
        }
      }
      if (onChange) onChange(current);
    }
  };

  return (
    <Flex flexDirection={direction} gap={8}>
      {choices.map((x) => {
        return (
          <StyledButton
            key={x.id.toString()}
            data-testid={`choice-input-${x.id}`}
            startIcon={
              x.adornmentLeft && <Flex minWidth={25}>{x.adornmentLeft}</Flex>
            }
            endIcon={
              <Flex flex={1} justifyContent='flex-end'>
                {showIconCompletedOnSelected && selected.includes(x.id) ? (
                  <IconCompleted />
                ) : (
                  x.adornmentRight
                )}
              </Flex>
            }
            isSelected={selected.includes(x.id)}
            readonly={readonly}
            onClick={() => handleClick(x.id)}
            variant='secondary'
            disabled={x.disabled}
            fullWidth={fullWidth}
            disableRipple={disableRipple}
          >
            {x.title}
          </StyledButton>
        );
      })}
    </Flex>
  );
};

export default ChoiceInput;
